export default __webpack_public_path__ + "static/media/rp.962583d9.svg";